export default {
  image: "picture.png",
  name: "Victor Monteiro Cunha",
  birthday: new Date("06/02/1998"),
  email: "victor.monteiro.cunha@gmail.com",
  phone: "(14) 98808-1946",
  address: "R. Andrea Camargo de Oliveira, 1-50 | Bauru, SP - 17047-287"
};
